import { useState, useEffect } from "react";
import {Typography, Modal, Box, TextField, InputAdornment, Grid} from '@mui/material';

import OutlinedButton from '../Button/OutlinedButton/OutlinedButton';
import SectionSpinner from "../Loading/SectionSpinner/SectionSpinner";
import ShoeSize from "./ShoeSize";

import './AddUserModal.css';


const modal_style = {
  position: 'absolute',
  top: '20px',
  left: '50%',
  transform: 'translate(-50%, 0px)',
  width: '60vw',
  bgcolor: 'rgba(255,255,255,0.05)',
  backdropFilter: 'blur(20px)',
  borderRadius: '5px',
  boxShadow: '0px 20px 50px #00000029',
  p: 4,
};

const inputProps = {
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
};


function AddUserModal(props) {

    const [open, setOpen] = useState(false);
    

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [twitter, setTwitter] = useState('');
    const [shoeData, setShoeData] = useState({"region":"", "size":""});
    
    const [invalidForm, setInvalidForm] = useState(true);
    const [lockForm, setLockForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({message:'', firstName:false, lastName:false, email:false, twitter:false});


    function handleOpen(){
        setOpen(true);
    }
    function handleClose(){
        // Prevent closing when we are awaiting a reply.
        if(!lockForm){
            setOpen(false);
        }
    }

    function handleChange(field, value){
        if(field === "firstName"){
            setFirstName(value);
        }
        else if(field === "lastName"){
            setLastName(value);
        }
        else if(field === "email"){
            setEmail(value);
        }
        else if(field === "twitter"){
            setTwitter(value);
        }
    }

    function checkEmail(email) {
        const regex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/;
        return regex.test(email);
    }

    function checkFormData(){
        if( (firstName !== "") && (lastName !== "") && (checkEmail(email)) && (twitter !== "") ){
            setInvalidForm(false);
        }else{
            setInvalidForm(true);
        }
    }

    const handleShoeChange = (shoe_data) => {
        setShoeData(shoe_data);
        console.log("handleShoeChange called");
        console.log(shoe_data);
    };

    /*

    // Not needed as the form is disabled until there is valid data.

    function validateForm(){
        if( (firstName !== "") && (lastName !== "") && (checkEmail(email)) && (twitter !== "") ){
            setInvalidForm(false);
        }else{
            setInvalidForm(true);

            if(firstName === ""){
                setErrors((prevState) => ({
                    ...prevState,
                    firstName: true,
                }));
            }
            else{
                setErrors((prevState) => ({
                    ...prevState,
                    firstName: false,
                }));
            }

            if(lastName === ""){
                setErrors((prevState) => ({
                    ...prevState,
                    lastName: true,
                }));
            }
            else{
                setErrors((prevState) => ({
                    ...prevState,
                    lastName: false,
                }));
            }

            if(!checkEmail(email)){
                setErrors((prevState) => ({
                    ...prevState,
                    email: true,
                }));
            }
            else{
                setErrors((prevState) => ({
                    ...prevState,
                    email: false,
                }));
            }

            if(twitter === ""){
                setErrors((prevState) => ({
                    ...prevState,
                    twitter: true,
                }));
            }
            else{
                setErrors((prevState) => ({
                    ...prevState,
                    twitter: false,
                }));
            }

            setErrors((prevState) => ({
                ...prevState,
                message: 'Please fill in all required fields.',
            }));

        }
    }
    */

    async function handleForm(){
        console.log("Handle new user form");

        // Change the submit button to a spinner and lock form inputs
        setLoading(true);
        setLockForm(true);

        var new_user_data = {
            fname: firstName,
            sname: lastName,
            email: email,
            twitter: twitter,
            shoe_size: shoeData.size,
            shoe_size_type: shoeData.region
        }

        console.log(new_user_data);

        return fetch(process.env.REACT_APP_API_ENDPOINT+'squadslive/addUser', {
            method: 'POST',
            headers: {
                'Authorization': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(new_user_data)
        })
        .then(res => res.json())
        .then(function (response){    
            if(response.code === 200){
                
                props.returnNewUser(response.data);

                setOpen(false);
                setLoading(false);
                setLockForm(false);

                setFirstName('');
                setLastName('');
                setEmail('');
                setTwitter('');

                return true;

            }else{
                console.log("An error occured processing the data.");
                return false;
            }        
        })




    }

    useEffect(() => {
        checkFormData();
    },[firstName, lastName, email, twitter]);

    useEffect(() => {
        console.log(errors);
    },[errors]);

    if(props.loadingState){
        return (
            <></>
        )
    }
    else{
        return (
        <div>

            <div style={{width: "100%", textAlign: "right"}}>
                <OutlinedButton
                    text={'+ Add User'}
                    onClick={handleOpen}
                />
            </div>

            <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={modal_style} className="rezzil-shine">
                <Typography id="modal-modal-title" variant="h6" component="h2" sx={{color:"#ffffff", mb:2}}>
                    Add user
                </Typography>

                <Box
                    component="form"
                    onSubmit={handleForm}
                    sx={{mb:2}}
                    noValidate
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="new-user-firstname"
                                label="First Name"
                                name="new-user-firstname"
                                type="text"
                                onChange={event => handleChange('firstName', event.target.value)}
                                autoFocus
                                disabled={lockForm}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="new-user-lastname"
                                label="Last Name"
                                name="new-user-lastname"
                                type="text"
                                onChange={event => handleChange('lastName', event.target.value)}
                                disabled={lockForm}
                            />
                        </Grid>

                    </Grid>
                        
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="new-user-email"
                        label="Email Address"
                        name="new-user-email"
                        type="email"
                        onChange={event => handleChange('email', event.target.value)}
                        disabled={lockForm}
                    />

                    <TextField
                        margin="normal"
                        fullWidth
                        id="new-user-twitter"
                        label="Twitter Username"
                        name="new-user-twitter"
                        type="text"

                        inputProps={inputProps}

                        sx={{mb:3}}
                        onChange={event => handleChange('twitter', event.target.value)}
                        disabled={lockForm}

                        InputProps={{
                            startAdornment: <InputAdornment position="start">@</InputAdornment>,
                        }}
                    />

                    <ShoeSize handleChange={handleShoeChange} selectedItem={shoeData} loadingState={loading}/>

                </Box>

                {
                    loading &&
                    <SectionSpinner/>
                }
                {
                    !loading &&
                    <OutlinedButton
                        text={'Create user'}
                        onClick={handleForm}
                        fullWidth
                        disabled={invalidForm}
                    />
                }

                

                
            </Box>
            </Modal>
        </div>
        );
    }
    
  }
  

  export default AddUserModal;